import { useEffect, useMemo, useRef, useState } from 'react';

const loadImage = (url: string) =>
  new Promise<void>((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve();
    img.onerror = () => reject();
    img.src = url;
  });

const useImageLoader = (urls: string[]) => {
  const memoizedUrls = useMemo(() => urls, [urls.join(',')]);

  // using a useRef to ensure that the loaded state is for the current urls
  const loadedUrls = useRef<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const loadImages = async () => {
      const promises = memoizedUrls.map((url) => loadImage(url));
      await Promise.allSettled(promises);

      loadedUrls.current = memoizedUrls;
      setLoading(false);
    };

    loadImages();
  }, [memoizedUrls]);

  return loading || loadedUrls.current !== memoizedUrls;
};

export default useImageLoader;
